<template>
<!-- <PanelDisplay :id="id" :systemId="systemId" :mode="'view'" @Loading="onLayoutLoading" @Update="onLayoutUpdate" @AfterDataRender="afterDataRender" ref="PanelDisplay"></PanelDisplay> -->
<div class="pt1x posR">
	<Loading ref="Loading"></Loading>
	<!--没有组件、有组件没有定位、有组件没有定位有编辑权限-->
	<!-- <NoData v-if="mode=='view'&&displayList&&displayList.length==0&&(data&&data.length!=0&&doPermissions('A/B/A3')==false)||data&&data.length==0"></NoData> -->
	<div class="classGroup cField_E bdSub_E tra-fast_E">
		<button :class="{active:displayType=='a'}" @click="changeDisplayType('a')" type="button">{{$t('cmd109',['物理布局'])}}</button>
		<button :class="{active:displayType=='b'}" @click="changeDisplayType('b')" type="button" onclick="statistic('A29','A2912')">{{$t('cmd110',['电气布局'])}}</button>
	</div>
	<div v-if="mode=='view'&&displayList&&displayList.length==0&&doPermissions('A/B/A3',{targetCode:'A1',codeList:clone(roleCode)})" v-permissions="'A/B/A3'" permission-type="none" class="goToEdit taC">
		<button class="sizeM bdSub boxR pl1x pr1x hover-bg-highLight" @click="edit" type="button" onclick="statistic('A33','A3302')">{{$t('cmd289',['点击这里编辑系统布局'])}}</button>
		<div class="mt1x">{{$t('phrase917',['目前支持的设备：组件，请确保设备都已添加到电站后开始编辑系统布局'])}}</div>
	</div>
	<div v-if="displayList&&displayList.length" class="controlGroup boxR bgContent cSub bdSub_E hover-c-main_E tra-fast_E dpB_E w2x_E h2x_E" :class="{disable:lock}">
		<button class="fSub hover-f-main" @click="resetView">
			<Icon name="resetView" class="w1x h1x" />
		</button>
		<div class="addOn addOn-top3x taC peN">
			N<br><Icon name="posArrow-up" class="dpIB w1x h1x fSub mt05x" :sizeBase="'xs'" />
		</div>
		<button class="fa fa-plus" type="button" @click="zoomIn"></button>
		<button class="fa fa-minus" type="button" @click="zoomOut"></button>
	</div>
	<button v-show="isPreview" style="position: absolute;bottom: 2em;left:50%;transform: translate(-50%, 0);-webkit-transform: translate(-50%, -50%);text-align: center;z-index: 1" class="functionBtn boxR" @click="cancelPreview">{{$t('cmd290',['退出预览'])}}</button>
	<div class="layoutView mt1x boxR posR curM ofH" fillHeight="lastHeight,-space">
		<div v-if="mode=='view'" class="panelInfo bgContent bdSub lh15" status="hide" @click.stop="" @mousedown.stop="">
			<div field="deviceSn" class="cb ofH">
				<span class="fs14x fL">{{panelOption.active?panelOption.active.customData.sn:"--"}}</span>
				<a class="fR tra-fast" v-if="panelOption.active" v-permissions="'B/A/A5'" permission-type="none" @click="comDetail(panelOption.active.customData)">{{$t('word1356',['更多'])}}</a>
			</div>
			<div v-if="timeType=='day'" field="generationPower">{{$t('word176',['发电功率'])+': '+(panelOption.active&&panelOption.active.customData.generationPower!=null?floatFix(panelOption.active.customData.generationPower,2)+" W":"--")}}</div>
			<div v-if="timeType=='day'" field="collectionTime">{{$t('word210',['时间'])+': '+(panelOption.active&&panelOption.active.customData.collectionTime?timeFormat(panelOption.active.customData.collectionTime,'utc','%Y/%m/%d %H:%M',{offset:timeZoneCode}):"--")}}</div>
			<div v-if="timeType=='month'" field="generationValue">{{$t('word358',['当日发电量'])+': '+(panelOption.active&&panelOption.active.customData.generationValue!=null?floatFix(panelOption.active.customData.generationValue,2)+" kWh":"--")}}</div>
			<div v-if="timeType=='month'" field="collectionTime">{{$t('word210',['时间'])+': '+(panelOption.active&&panelOption.active.customData.collectionTime?timeFormat(panelOption.active.customData.collectionTime,'utc','%Y/%m/%d',{offset:timeZoneCode}):"--")}}</div>
			<!-- <div v-if="timeType=='month'" field="collectionDay">{{$t('word210',['时间'])+': '+(panelOption.active&&panelOption.active.customData.collectionDay?dateFormat(panelOption.active.customData.collectionDay):"--")}}</div> -->
			<div v-if="timeType=='year'" field="generationValue">
				{{$t('word359',['当月发电量'])+': '+(panelOption.active&&panelOption.active.customData.generationValue!=null?floatFix(panelOption.active.customData.generationValue,2)+" kWh":"--")}}
			</div>
			<div v-if="timeType=='year'" field="collectionYear_collectionMonth">
				{{$t('word210',['时间'])+': '+((panelOption.active&&panelOption.active.customData.collectionYear && panelOption.active.customData.collectionMonth)?panelOption.active.customData.collectionYear+'/'+panelOption.active.customData.collectionMonth:"--")}}
			</div>
			<div v-if="timeType=='all'" field="generationValue">{{$t('word360',['当年发电量'])+': '+(panelOption.active&&panelOption.active.customData.generationValue!=null?floatFix(panelOption.active.customData.generationValue,2)+" kWh":"--")}}</div>
			<div v-if="timeType=='all'" field="collectionYear">{{$t('word210',['时间'])+': '+(panelOption.active&&panelOption.active.customData.collectionYear?panelOption.active.customData.collectionYear:"--")}}</div>
			<!-- <Loading ref="LoadingForPanelInfo"></Loading> -->
		</div>
		<div class="panelTip bgContent bdSub lh15" status="hide">SN:{{panelOption.hover.sn||"--"}}</div>
		<NoData v-if="mode=='view'&&displayList&&displayList.length==0&&doPermissions('A/B/A3')==false" class="noData"></NoData>
		<NoData v-if="mode=='edit'&&displayList&&displayList.length==0" class="noData"></NoData>
	</div>
</div>
</template>
<script>
import * as lib from '@/util/lib';

import Loading from '@/components/common/ui/Loading';
import NoData from '@/components/common/ui/NoResult';

import Edit from '@/view/maintain/light/plant/part/layout/Edit';
import ViewDetail from '@/view/device/operationalAudit/ViewDetail.vue';

import {apiGetLayout} from '@/api/maintain/layout/index';

export default{
	name:"PanelDisplay",
	components:{Loading,NoData},
	props:{
		id:{
			type:Number,
			default:null
		},
		systemId:{
			type:Number,
			default:null
		},
		plantInfo:{//电站信息
			type:Object,
			default:()=>({})
		},
		mode:{//激活的索引项
			type:String,
			default:"view"
    },
     roleCode: {
      type: Array,
			default: () => {
        return []
        }
    },
		timeType:{//事件档位
			type:String,
			default:"day"
		},
		timeZoneCode:{//电站时区
			type:String,
			default:stage.time.timeZoneCode
		}
	},
	data(){
		return{
      run:false,
      newX: 0,
      newY: 0,
      newZ: 0,
      MaxZ: 0,
			displayType:"a",//a:物理布局,b:电气布局
			data:null,//组件数据
			bg:null,//组件背景
			panelOption:{
				plantId:this.id,
				systemId:this.systemId,
				"baseSrc":`${stage.loc.baseRouter}static/image/solarPanel.svg`,
				"width":stage.space*4,
				"height":stage.space*6,
				space:0,
				keyPos:{//坐标key设置
					a:["x","y"],
					b:["gn","gi"]//电气布局坐标和产品要求正好互换
				},
				public:{//公共资源
					planeGeometry:null,//太阳能板几何体
					panelFace:null,//太阳能板贴图几何体
				},
				valTexture:{},//保存数据贴图
				"splitStr":",",//编辑模式下x和y的中间字符
				// "fontSize":[24,36],
				// "addition":200,
				"maxX":0,
				"maxY":0,
				selector:{//html3d部分的选择
					"panelInfo":this.mode=="view"?".panelInfo":"",
					"panelTip":".panelTip"
				},
				"active":null,
				"hover":{},
				infoWidth:0//记录信息面板的宽度
			},
			baseAniSec:this.mode=="view"?2:1,//基础动画秒数
			curComponent:null,
			lastDataOption:null,//保存渲染组件数据用
			staticResource:{//静态资源集合
				solarPanel:null,//太阳能板贴图
			},
			renderWebGL:null,//webGL渲染器
			renderCSS2D:null,//css2D渲染器

			panelInfo:null,//面板信息
			panelTip:null,//面板提示信息

			mouse:null,//鼠标
			downPoint:[],//点击坐标

			renderTime:new Date().getTime(),//渲染控制，防止卡死

			$root:null,//总容器的jqueryDOM
			// allItemList:[],//所有物件列表
			displayList:null,//纯主展示物件列表
			typeBLineList:[],//电气布局的连线列表
			interactionList:[],//可交互元素的列表
			panelObjList:{},//组件key索引
			// eTower:null,
			lock:false,//相机交互开关
			click:true,//防止点击后拖动后依然触发click事件
			root:null,//总场景
			camera:null,//摄像机
			cameraSys:{},//摄像机参数

			threeLoad:{"0":"","1":"","2":""},//three所需要的js和运行步骤
			threeLoadedCount:0,//已加载的数量
			isPreview:false
		}
	},
	watch:{
		// data:{
		// 	handler:function(data){
		// 		if(this.threeLoadedCount>=3&&this.run){
		// 			this.$nextTick(()=>{//给列表处理留出时间
		// 				this.newPanel(this.data);
		// 			});
		// 		}
		// 	},
		// 	deep: true
		// }
		// "panelOption.hover":{//监测hover组件变化
		// 	handler:function(data,old){
		// 		if(data&&data.name!=old.name){
		// 			this.panelTipCtrl(data);
		// 		}
		// 	},
		// 	deep: true
		// }
	},
	methods:{
		timeFormat: lib.timeFormat,
		dateFormat: lib.dateFormat,
		floatFix: lib.floatFix,
    doPermissions:lib.doPermissions,
    clone (arr) {
			return _.cloneDeep(arr)
		},
		show:function(){
			lib.fillHeight();
			this.run=true;
			this.threeReady();
		},
		emitUpdate:function(){//emit Update事件
			this.$emit("Update",{layoutItem:this.data,layoutBg:this.bg});
		},
		setCurComponent(curC){
			this.curComponent = curC;
		},
		threeReady:function(name,jsString=""){//登记并判断threejs的加载
			if(name){
				++this.threeLoadedCount;
				this.threeLoad[name]=jsString;
				if(this.threeLoadedCount==3){
					let $this=this;
					
					$.each(new Array(3),function(index){//按顺序执行外挂js
						let js=$this.threeLoad[String(index)];
						if(js) eval(js);
					});
					this.root=new THREE.Scene();

					// if ( webglAvailable() ) {
					// 	renderer = new THREE.WebGLRenderer();
					// } else {
					// 	renderer = new THREE.CanvasRenderer();
					// }
					this.renderWebGL=new THREE.WebGLRenderer({
						antialias:true
					});
					this.renderWebGL.setClearColor(0xFFFFFF,1);
					this.mouse=new THREE.Vector2();

					this.panelOption.public.panelGeometry=new THREE.PlaneGeometry(this.panelOption.width,this.panelOption.height,1);

					$(window).on("resize",this.resize);
					// this.render();
					// panel.position.set(0,0,0);
					// this.root.add(panel);
					// this.data.push(panel);
					// var raycaster = new THREE.Raycaster();
					// var mouse = new THREE.Vector2();
					// function render() {
					// 	// update the picking ray with the camera and mouse position
					// 	raycaster.setFromCamera( mouse, this.camera );
					// 	// calculate objects intersecting the picking ray
					// 	var intersects = raycaster.intersectObjects( this.root.children );
					// 	for ( var i = 0; i < intersects.length; i++ ) {
					// 		intersects[ i ].object.material.color.set( 0xff0000,.6);
					// 	}
					// 	renderer.render(this.root,this.camera);
					// }
					// window.addEventListener( 'mousemove', onMouseMove, false );
					// window.requestAnimationFrame(this.render);

					this.renderCSS2D=new THREE.CSS2DRenderer();
					this.build($($this.$el).find(".layoutView"));
					if(this.run&&this.data){//需要运行
						this.newPanel(this.data);
					}
				}
			}
			else if(this.root&&this.run&&this.data){
				this.resize();
				this.newPanel(this.data);
			}
		},
		load:function(data={}){//加载布局数据,传入api所需要的参数
			if(this.panelOption.plantId&&this.panelOption.systemId){//拿全数据才走接口
				if(data.plantId) this.panelOption.plantId=data.plantId;//更新参数
				if(data.systemId) this.panelOption.systemId=data.systemId;//更新参数

				if(data.data){//加载现有数据
					this.data=data.data.layoutItem;
					// this.bg=data.layoutBg;
					this.emitUpdate();
					this.$refs.Loading.hide();
					if(this.threeLoadedCount>=3&&this.run){
						this.$nextTick(()=>{//给列表处理留出时间
							this.newPanel(this.data);
						});
					}
				}
				else{
					if(this.$refs.Loading) this.$refs.Loading.show();
					this.$emit("Loading");
					apiGetLayout(this.panelOption.plantId,this.panelOption.systemId).then(data => {
						// let testQty=100*1;
						// $.each(new Array(testQty),(index)=>{//测试
						// 	data.layoutItem.push({
						// 		id:Math.round(Math.random()*99999999),
						// 		sn:"SN"+Math.round(Math.random()*99999999),
						// 		x:Math.round(Math.random()*testQty*.2)+1,
						// 		y:Math.round(Math.random()*testQty*.2)+1,
						// 		gi:testQty%Math.round(Math.random()*testQty*.2+1)+1,
						// 		gn:index+1
						// 	});
						// });
						this.data=data.layoutItem;
						this.bg=data.layoutBg;
						this.emitUpdate();
						this.$refs.Loading.hide();
						if(this.threeLoadedCount>=3&&this.run){
							this.$nextTick(()=>{//给列表处理留出时间
								this.newPanel(this.data);
							});
						}
					});
				}
			}
		},
		edit:function(){//编辑布局
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],Edit,
					{id:this.id,systemId:this.systemId},
					{Update:[this.load.bind(this)]},{}
				).then(({instance, childInstance}) => {
					childInstance.show(null,this.plantInfo,instance);
				}
			);
		},
		//布局系统
		webglAvailable:function(){
			try {
				var canvas = document.createElement( 'canvas' );
				return !!( window.WebGLRenderingContext && (
					canvas.getContext( 'webgl' ) ||
					canvas.getContext( 'experimental-webgl' ) )
				);
			} catch ( e ) {
				return false;
			}
		},
		// setMaxUnit:function(data){//设定参考色条的最大值
		// 	var valMax=findMax(data,{fix:true});
		// 	if(valMax>0) this.panelOption.valMax=valMax;
		// 	else valMax=this.panelOption.valMax;
		// 	if($("[chartDateBy][active]").attr("chartDateBy")!="day"){//其它档位传来的都是k单位
		// 		valMax*=1000;
		// 		// valMax=Math.floor(valMax);
		// 	}
		// 	// valMax=(valMax>=1000)? Math.floor(valMax/1000):valMax/1000;
		
		// 	var valUnit="";
		// 	if($("[chartDateBy][active]").attr("chartDateBy")=="day"){
		// 		valUnit=(valMax>=1000)? getLanguageStr("unit9","kW"):getLanguageStr("unit2","W");
		// 	}else valUnit=(valMax>=1000)? getLanguageStr("unit10","kWh"):getLanguageStr("unit46","Wh");
		// 	if(valMax>=1000) valMax=Math.floor(valMax/1000);
		// 	$(".maxUnit").html(valMax+valUnit);
		// },
		panelDrag:function(e){
			// e.preventDefault();
			// this.camera.position.x+=(this.downPoint[0]-e.clientX);//*(this.camera.position.z*.001)
			// this.camera.position.y-=this.downPoint[1]-e.clientY;
			// this.$root.css("cursor","move");
			if(Math.abs(this.downPoint[0]-e.clientX)>10||Math.abs(this.downPoint[1]-e.clientY)>10) this.click=false;
			TweenMax.killTweensOf(this.camera.position);

			TweenMax.to(this.camera.position,.5,{//越近越慢
				x:this.cameraSys.loc.x+(this.downPoint[0]-e.clientX)*(this.camera.position.z/100),
				y:this.cameraSys.loc.y-(this.downPoint[1]-e.clientY)*(this.camera.position.z/100),
				ease:Cubic.easeOut,
				onUpdate:()=>{
          if(this.camera.position.x<this.newX&&this.mode!=="view"){
             this.camera.position.x = this.newX
          }
          if(this.camera.position.y<this.newY&&this.mode!=="view"){
            this.camera.position.y = this.newY
          }
          this.render()
        },
				// onComplete:function(){}
			});
			// this.render();
			// return false;
		},
		panelDragEnd:function(e){
			// this.downPoint=[e.clientX,e.clientY];
			// this.render();

			$(document).off("mousemove",this.panelDrag);
			$(window).off("mouseup",this.panelDragEnd);
			this.$root.off("mouseleave",this.panelDragEnd);
			setTimeout(()=>{this.click=true;},0);
			// $(window).off("mouseleave",panelDragEnd);
		},
		render:function(){
			if(new Date().getTime()-this.renderTime>=5){//限制fps
				// this.camera.lookAt($.extend(true,{},this.camera.position),{z:0});
				this.renderWebGL.render(this.root,this.camera);
				this.renderCSS2D.render(this.root,this.camera);
				this.renderTime=new Date().getTime();
			}
			// else trace("已丢帧");
		},
		panelDataRender:function(data=[],unit,keyId,keyVal){//data:[]
			this.panelInfoCtrl();
			let $this=this;
			let max=-1;
			if(this.$root&&this.run&&this.displayList&&this.displayList.length){
				// if(this.lock==false&&data){//限制fps
					let valMap={};
					if(data.length){
						$.each(data,(index,val)=>{
							let panel=this.panelObjList[String(val[keyId])];
							// let pos=this.panelOption.keyPos[this.displayType];
							if(panel){//仅计算能够展示的数据
								if($.isNumeric(val[keyVal])&&val[keyVal]>max) max=val[keyVal];
							}
							valMap[val[keyId]]=val[keyVal];

							//更新组件信息板用的数据
							if(this.panelObjList[val[keyId]]){
								$.extend(true,this.panelObjList[val[keyId]].customData,val);
								if(this.panelOption.active&&this.panelOption.active.name==val[keyId]){
									// $.extend(true,this.panelOption.active.customData,val);
									// this.$nextTick(()=>{
									// 	this.panelOption.active.add(this.panelInfo);
									// 	trace(this.panelOption.active.customData,true)
									// });
								}
							}
						});
					}
					else if(this.mode=="view"&&this.lastDataOption){//没有组件发电数据就清空
						$.each(this.displayList,(index,panel)=>{
							panel.customData[this.lastDataOption.keyVal]=null;
							//清空时间数据
							panel.customData.collectionTime=null;
							panel.customData.collectionMonth=null;
							panel.customData.collectionYear=null;
						});
					}
					max=Math.ceil(max*1.2);
					// this.$root.find("[id]").each(function(){
						// var thisData=data[$(this).attr("id")],color=new THREE.Color(stage.color.main),alpha;
					// 	if(thisData!=undefined){
					// 		color=color.setHSL(color.getHSL().h,color.getHSL().s,1-thisData/1000*.7-.2).getStyle();
					// 		alpha=1;
					// 	}else{
					// 		thisData="- -";
					// 		color=stage.color.main;
					// 		alpha=.2;
					// 	}
					// 	$(this).html(thisData);
					// 	// TweenMax.to($(this),.5,{"background-color":color,alpha:alpha,ease:Cubic.easeInOut});
					// 	// TweenMax.set($(this),{"background-color":color,alpha:alpha});
					// 	$(this).css({
					// 		"background-color":color,
					// 		"opacity":alpha
					// 	});
					// });
					let hsl=new THREE.Color(stage.color.main).getHSL();
					$(this.displayList).each(function(index){
						// trace(this,true)
						var thisData=data.length? valMap[String(this.name)]:"";
						if($this.mode=="view"){//仅view模式随数据变色
							if($.isNumeric(thisData)){
								// this.material.color.setHSL(hsl.h,hsl.s,.4-(thisData?thisData/max*.4:0)+.3);
								this.material.color.setHSL(hsl.h,hsl.s,(thisData?thisData/max*.4:0)+.3);
							}
							else{
								// this.material.color.setHSL(hsl.h,0,.7);
								this.material.color.setHSL(hsl.h,0,.3);
							}
						}
						else this.material.color.set(stage.color.solarComp);
						// this.remove(this.getObjectByName("text"));
						var text="";
						if($this.mode=="view"){
							text=$.isNumeric(thisData)? Math.round(thisData*100)/100:"- -";
						}
						else{
							switch($this.displayType){
								case "a":
									text=this.xName+$this.panelOption.splitStr+this.yName;
									break;
								case "b":
									text=this.yName+$this.panelOption.splitStr+this.xName;
									break;
							}
						}
						this.getObjectByName("text").material.map=$this.newTextTexture(text,unit);
						TweenMax.allTo([this.material,this.children[0].material],.5,{opacity:text!="- -"? 1:.4,ease:Cubic.easeInOut});
						// this.material.opacity=.1;
					});
					TweenMax.to(this.root,.5,{onUpdate:this.render});
					// this.render();
					// this.lastDataOption=null;
				// }
				// else trace("已丢帧");
			}
			// else{//保存需要渲染的数据
				this.lastDataOption={
					data,unit,keyId,keyVal
				};
			// }
			this.$emit("AfterDataRender",max);
		},
		// designTest:function(data,type,$dom){//data:[{"id":String,"x":int,"y":int},....]检测排布数据是否合法
		// 	var pass=true;
		// 	//检测部分
		// 	var arraySys=[];//[[],["1","2"],[]]
		// 	$(data).each(function(index){//统计行
		// 		var row=Number(this.x);
		// 		var col=Number(this.y);
		// 		if(row>0){
		// 			if(!arraySys[row]) arraySys[row]=[];
		// 			if(data[index].domIndex!=undefined&&col>0) arraySys[row][data[index].domIndex]=col;
		// 			else if(col>0) arraySys[row].push(col);
		// 		}
		// 	});
		// 	// if(type=="a") trace(arraySys,true)
		// 	var selector=["",""];
		// 	switch(type){
		// 		case "a":selector=["[x]","[y]"];
		// 			break;
		// 		case "b":selector=["[x2]","[y2]"];
		// 			break;
		// 	}
		// 	$(arraySys).each(function(indexRoot){//以行为单位开始遍历
		// 		if($.isArray(this)&&this.length>0){
		// 			$(this).each(function(index,val){//以列为单位开始遍历
		// 				var tempArray=arraySys[indexRoot].concat();
		// 				tempArray[index]="";//为减少遍历，分阶段判断，第一步先找是否有重合的
		// 				var findIndex=$.inArray(val,tempArray);
		// 				// if(findIndex>-1&&findIndex!=index){//trace(findIndex+"|"+index+"v:"+val)
		// 				// 	pass=false;
		// 				// 	$dom.children().eq(findIndex).find(selector[0]).addClass("error");
		// 				// 	$dom.children().eq(findIndex).find(selector[1]).addClass("error");
		// 				// 	$dom.children().eq(indexRoot).find(selector[0]).addClass("error");
		// 				// 	$dom.children().eq(indexRoot).find(selector[1]).addClass("error");
		// 				// 	// return false;
		// 				// }
		// 				if(findIndex>-1){
		// 					pass=false;
		// 					if($dom){
		// 						$dom.children().eq(index).find(selector[0]).addClass("error");
		// 						$dom.children().eq(index).find(selector[1]).addClass("error");
		// 					}

		// 					var deled=0,del;
		// 					$(data).each(function(i){//查找重复的数据并移除
		// 						if(this.domIndex>=0&&this.domIndex===index){
		// 							del=data.splice(i-deled,1)[0];
		// 							++deled;
		// 						}
		// 						else if(this.domIndex==undefined&&this.y===val){
		// 							if(indexRoot==data[i-deled].x){
		// 								// trace(indexRoot+"|"+data[i-deled].x)
		// 								del=data.splice(i-deled,1)[0];
		// 								// trace(del);
		// 								++deled;
		// 							}
		// 						}
		// 					});
		// 					// $(arraySys[indexRoot]).each(function(){
		// 					// });
		// 				}
		// 			});
		// 			// if(pass==false) return;
		// 		}
		// 	});//trace("-------")
		// 	return [pass,data];
		// },
		notLost:function(newData){//检测新的排布数据中的组件是否有增减或有不同的组件
			let lost=false;
			//数量一致
			if(this.displayList&&newData.length==this.displayList.length){
				lost=true;
			}
			else return false;

			$.each(newData,(index,val)=>{
				if(lost==false&&this.panelObjList[String(val.id)]==undefined){//id全一致
					lost=true;
				}
				if(val[this.panelOption.keyPos.a[0]]&&val[this.panelOption.keyPos.a[1]]&&val[this.panelOption.keyPos.b[0]]&&val[this.panelOption.keyPos.b[1]]){//2种布局数据齐全
					lost=false;
				}
				else{
					// trace(val)
					lost=true;
				}
				if(lost) return false;
			});

			// if(data.length==this.data.length){
			// 	var idArray=[];
			// 	$(this.data).each(function(){
			// 		idArray.push(this.name);
			// 	});
			// 	// idStr=idStr.join(" ");trace(idStr)
			// 	$(data).each(function(){
			// 		if( $.inArray(this.id,idArray)<0 ){
			// 			lost=true;
			// 			return;
			// 		}//else trace($.inArray(this.id,idArray))
			// 	});
			// }else lost=true;
			return !lost;
		},
		// function animate(){
		// 	requestAnimationFrame( animate );
		// 	this.render();
		// }
		newTextTexture:function(string,unit=""){//创建并新的文本贴图
			if(this.panelOption.valTexture[string+unit]){
				return this.panelOption.valTexture[string+unit];
			}
			else{
				var textConfig={
					color:"#fff",//string=="- -"? stage.color.main:
					size:stage.space*1,
					// fontFamily:"monaco"
					fontFamily:"Arial"
				}
				var canvas=document.createElement("canvas");
				var context=canvas.getContext("2d");
				// canvas.width=this.panelOption.width;
				// canvas.height=this.panelOption.height;
				canvas.width=this.panelOption.width;
				canvas.height=textConfig.size*2*1.6;
				// context.rect(0,0,this.panelOption.width,canvas.height);
				// context.strokeStyle="red";
				// context.stroke();
				context.font="700 "+textConfig.size+"px "+textConfig.fontFamily;
				// context.lineWidth=1;
				context.textAlign="center";
				context.fillStyle=textConfig.color;
				context.shadowBlur=1;
				context.shadowColor="rgba(0,0,0,.2)";
				context.shadowOffsetY=1;
				if(string=="- -"||this.mode=="edit"){
					context.fillText(string,this.panelOption.width/2,canvas.height/2*.8);
				}
				else{
					context.fillText(string,this.panelOption.width/2,canvas.height/2-textConfig.size/2);
					context.fillText(unit,this.panelOption.width/2,canvas.height/2+textConfig.size/2);
				}
				var texture=new THREE.Texture(canvas);
				texture.minFilter=THREE.LinearFilter;
				texture.anisotropy=4;
				$.extend(texture.offset,{
					// y:-(this.panelOption.height-canvas.height)*1.7/this.panelOption.height
					y:-canvas.height/2*1.2/this.panelOption.height
				});
				$.extend(texture.repeat,{
					y:this.panelOption.height/canvas.height
				});
				texture.needsUpdate=true;
				this.panelOption.valTexture[string+unit]=texture;
				// $(this.$el).find(".layoutView").addClass("bgSub").prepend(canvas);//测试贴图
				return texture;
			}
		},
		setPanelInfoSize:function(){
			// var baseFontSize=parseInt($("html").css("font-size"));
			// $(this.panelOption.panelInfo).css("font-size",( (this.camera.position.z/this.cameraSys.max.z)*(baseFontSize*10))+"px");
			// $(this.panelOption.panelTip).css("font-size",( (this.camera.position.z/this.cameraSys.max.z)*(baseFontSize*10))+"px");
			// if(this.panelOption.active&&$(this.panelOption.panelInfo).css("opacity")==0){
			// 	// this.panelInfo.position.x=;
			// 	// this.panelInfo.position.y=this.panelOption.active.position.y;
			// 	this.panelInfo.position.set(
			// 		this.panelOption.active.position.x+this.panelOption.width+$(this.panelInfo.element).width()/2,
			// 		this.panelOption.active.position.y,
			// 		0
			// 		);
			// }
			// if(this.panelOption.active){trace(this.panelInfo)
			// 	TweenMax.to(this.panelInfo.position,.5,{
			// 		x:this.panelOption.active.position.x+this.panelOption.width+$(this.panelInfo.element).width()/2,
			// 		y:this.panelOption.active.position.y,
			// 		z:50,
			// 		ease:Cubic.easeInOut,
			// 		onUpdate:this.render
			// 	});
			// }
		},
		activeAction:function(target,action){//取消激活
			switch(action){
				case "hide":
					TweenMax.to(target.position,.5,{z:0,ease:Expo.easeInOut});
					TweenMax.to(target.scale,.5,{x:1,y:1,ease:Expo.easeInOut});
					break;
				case "show":
					this.setPanelInfoSize();
					TweenMax.to(target.position,.5,{z:20,ease:Expo.easeInOut});
					TweenMax.to(target.scale,.5,{x:1.4,y:1.4,ease:Expo.easeInOut});
					break;
				case "":
					break;
			}
		},
		// getPanelTimeData:function(deviceId,timeType){//查询组件的时间点数据
		// 	apiGetTimeData();
		// },
		panelInfoCtrl:function(active){
			if(this.panelInfo){
				if(active){//有激活
					// $(this.$el).find(this.panelOption.selector.panelInfo).attr("status","show");
					// TweenMax.to(this.panelInfo.position,.5,{x:this.panelOption.active.position.x,y:this.panelOption.active.position.y,ease:Expo.easeInOut});
					if(this.panelOption.active!==active){//点击新激活
						if(this.panelOption.active){//有别的激活
							this.activeAction(this.panelOption.active,"hide");
						}
						this.panelOption.active=active;
						this.panelOption.active.add(this.panelInfo);
						this.panelInfo.position.set(0,0,0);//this.panelOption.height/2
						this.activeAction(this.panelOption.active,"show");
						// this.getPanelTimeData(this.panelOption.active.customData.id,this.timeType);
						TweenMax.fromTo(this.panelInfo.element,.5,{autoAlpha:0},{autoAlpha:1,ease:Expo.easeInOut});
						this.panelTipCtrl();//关闭tip显示
					}
					// else{//点击的是自己，关闭
					// 	this.panelInfoCtrl();
					// 	return false;
					// }
				}
				else{//没有激活
					if(this.panelOption.active){
						// name=this.panelOption.active.name;
						this.activeAction(this.panelOption.active,"hide");
						TweenMax.to(this.panelInfo.element,.5,{autoAlpha:0,ease:Expo.easeInOut,onComplete:()=>{
							this.panelOption.active=null;
						}});
					}
				}
				TweenMax.to(this.root,.5,{onUpdate:this.render,onComplete:()=>{
					// this.click=true;
				}});

				$(this.panelInfo.element).attr("status",active?"show":"hide");
			}
		},
		panelTipCtrl:function(panel){
			// TweenMax.killTweensOf(this.panelTip.element);
			if(panel&&(this.panelOption.hover.name!=panel.name||$(this.panelTip.element).attr("status")!="show")){
				this.panelOption.hover=panel;
				this.panelOption.hover.add(this.panelTip);
				this.panelTip.position.set(0,-this.panelOption.height*.55,0);
				// $(this.panelOption.selector.panelTip).html("SN:"+panel.sn);
				if(this.panelOption.active&&this.panelOption.hover.name!=this.panelOption.active.name||!this.panelOption.active){
					$(this.panelTip.element).attr("status","show");
					// TweenMax.to(this.panelTip.position,.5,{
					// 	x:panel.position.x,
					// 	y:panel.position.y-this.panelOption.height*.45,
					// 	// z:50,
					// 	ease:Cubic.easeInOut,
					// 	onUpdate:this.render
					// });
					TweenMax.killTweensOf(this.panelTip.element);
					TweenMax.fromTo(this.panelTip.element,.5,{autoAlpha:0},{autoAlpha:1,ease:Expo.easeInOut});
				}
				// else console.log(this.panelOption.hover.name,this.panelOption.active?this.panelOption.active.name:"--")
			}
			else if(!panel&$(this.$el).find(this.panelOption.selector.panelTip).attr("status")!="hide"){
				this.panelOption.hover.onHover=false;
				$(this.panelTip.element).attr("status","hide");
				TweenMax.killTweensOf(this.panelTip.element);
				TweenMax.to(this.panelTip.element,.5,{autoAlpha:0,ease:Expo.easeInOut});
			}
			// else if(panel){
			// 	console.log("-!-",panel.sn,this.panelOption.hover.onHover)
			// }
			TweenMax.to(this.root,.5,{onUpdate:this.render,onComplete:()=>{
				// this.click=true;
			}});
		},
		changeDisplayType(type){//切换布局
			if(type!=this.displayType){
				this.displayType=type;
				this.clearTypeBLine();
				this.newPanel(this.data);
			}
		},
		getLayoutTypeB:function(data){//电气布局需要特殊处理
			//将设计数据按x分开数组
			var newArray=[];
			$(data).each(function(){
				if(!newArray[this.x]) newArray[this.x]=[];
				newArray[this.x].push(this);
			});
			var deled=0,maxY=0;
			$(newArray).each(function(index){//剔除空白内容
				if($.isArray(this)&&this.length==0){
					newArray.splice(index-deled,1);
					++deled;
				}else if($.isArray(this)&&this.length>maxY) maxY=this.length;
			});
			$(newArray).each(function(indexX){//顺序重排
				// var max=this.length;
				$( sortData(this,{byKey:"y"}) ).each(function(indexY){
					this.xName=this.x;
					this.yName=this.y;
					this.x=indexX+1;
					this.y=maxY-indexY;
				});
			});
			// trace(newArray,true)
			return data;
		},
		start:function(action){
			let $this=this;
			this.lock=false;
			// this.panelDataRender(this.panelOption.dataRender);
			this.lock=true;
			switch(action){
				case "reDesign":
					// var aniTime=(this.mode=="view")? 2.5:1;
					// TweenMax.to(eTower.position,aniTime,{
					// 	x:(this.panelOption.width+this.panelOption.space)*this.panelOption.maxX/2-(this.panelOption.width+this.panelOption.space)/2,
					// 	y:(this.panelOption.height+this.panelOption.space)*this.panelOption.maxY+this.panelOption.height/3,
					// 	ease:Cubic.easeInOut
					// });
					this.updateMaxPosition();
					$.each(this.data,(index,val)=>{
						let thisPanel=this.panelObjList[String(val.id)];
						let x=val[this.panelOption.keyPos[this.displayType][0]];
						let y=val[this.panelOption.keyPos[this.displayType][1]];
						thisPanel.xName=x;//更新文本需要的坐标值
						thisPanel.yName=y;
						let posX,posY;
						// TweenMax.to(this.position,2,{bezier:{values:[{x:(x+this.position.x)/2+Math.random()*400-200,y:(y+this.position.y)/2+Math.random()*400-200,z:Math.random()*4000-2000},{x:x,y:y,z:0}]},ease:Cubic.easeInOut,delay:Math.random()*100/100});
						posX=(this.panelOption.width+this.panelOption.space)*(x-1);
						posY=(this.panelOption.height+this.panelOption.space)*(y-1);

						// switch($this.displayType){
						// 	case "a":
						// 		break;
						// 	case "b":
						// 		// if(x>this.panelOption.maxY) this.panelOption.maxY=x;//记录最大y个数
						// 		// if(y>this.panelOption.maxX) this.panelOption.maxX=y;//记录最大x个数
						// 		posX=(this.panelOption.width+this.panelOption.space)*(y-1);
						// 		posY=(this.panelOption.height+this.panelOption.space)*(x-1);
						// 		break;
						// }
						TweenMax.to(thisPanel.position,this.baseAniSec,{x:posX,y:posY,ease:Cubic.easeInOut,delay:Math.random()*this.baseAniSec*.4});
					});
						// TweenMax.to(this,3,{onUpdate:this.render,onComplete:()=>{this.lock=false;}});
					if(this.mode=="view"){//仅view模式有摄像机动作
						TweenMax.killTweensOf(this.camera.position);
						TweenMax.to(this.camera.position,1.5,{
							x:this.cameraSys.def().x,
							y:this.cameraSys.def().y,
							z:this.cameraSys.def().z*1.2,
							ease:Cubic.easeInOut,
							// onStart:()=>{$(this.renderWebGL.domElement).css("display","");},
							onUpdate:this.render,
							onComplete:()=>{
								TweenMax.to(this.camera.position,1.5,{
									// x:(this.panelOption.width+this.panelOption.space)*this.panelOption.maxX*.5,
									// y:(this.panelOption.height+this.panelOption.space)*(this.panelOption.maxY-1.5),
									z:this.cameraSys.def().z,ease:Cubic.easeInOut,
									onUpdate:this.render,
									onComplete:()=>{this.lock=false;this.setPanelInfoSize();this.zoomEndFun();}
								});
							}
						});
					}
					else{
						this.panelDataRender();
						TweenMax.to(this.$root,this.baseAniSec*1.5,{onUpdate:this.render,onComplete:()=>{this.lock=false;this.zoomEndFun();}});
					}
					break;
				default:
					$(this.displayList).each(function(){
						if(this.name!="backgroundPanel"){
							TweenMax.fromTo(this.position,$this.baseAniSec,{z:$this.cameraSys.def().z*2},{z:0,ease:Cubic.easeOut,delay:Math.random()*$this.baseAniSec*.6});
						}
					});
					// eTower.position.set((this.panelOption.width+this.panelOption.space)*this.panelOption.maxX/2-(this.panelOption.width+this.panelOption.space)/2,(this.panelOption.height+this.panelOption.space)*this.panelOption.maxY+this.panelOption.height/3,0);
					//start1
					// this.camera.position.set(-(this.panelOption.width+this.panelOption.space)*this.panelOption.maxX,-(this.panelOption.height+this.panelOption.space)*this.panelOption.maxY*2,this.cameraSys.min.z*50);//设置相机的位置坐标
					// TweenMax.to(this.camera.position,5,{x:(this.panelOption.width+this.panelOption.space)*this.panelOption.maxX/2,y:(this.panelOption.height+this.panelOption.space)*this.panelOption.maxY/2-this.panelOption.height/3,z:this.cameraSys.min.z*5,ease:Cubic.easeOut,
					// 	onStart:()=>{$(this.renderWebGL.domElement).css("display","");},
					// 	onUpdate:this.render,
					// 	onComplete:()=>{this.lock=false;}
					// });
					// TweenMax.to(this.cameraSys.look,5,{x:(this.panelOption.width+this.panelOption.space)*this.panelOption.maxX/2,y:(this.panelOption.height+this.panelOption.space)*this.panelOption.maxY/2-this.panelOption.height/3,ease:Cubic.easeInOut,onUpdate:function(){this.camera.lookAt(this.cameraSys.look);}});
					//start2
					TweenMax.killTweensOf(this.camera.position);
					let def=this.cameraSys.def();
					this.camera.position.set(def.x,0,0);//设置相机的位置坐标
					TweenMax.to(this.camera.position,this.baseAniSec*2,{x:def.x,y:def.y,z:def.z,ease:Cubic.easeOut,
						onStart:()=>{$(this.renderWebGL.domElement).css("display","");},
						onUpdate:this.render,
						onComplete:()=>{this.lock=false;this.setPanelInfoSize();}
					});
					break;
			}
		},
		loadResource:function(name,loadedFn){//判断加载状态，或加载资源
			let out=true;
			let $this=this;
			if(this.staticResource[name]){
				if(loadedFn) loadedFn();
			}
			else{
				out=false;
				switch(name){
					case "solarPanel":
						let loader = new THREE.TextureLoader();
						loader.load($this.panelOption.baseSrc,texture=>{
							// texture.minFilter=THREE.LinearFilter;
							texture.anisotropy=4;
							// $.extend(texture.offset,{
							// 	x:.14
							// });
							// $.extend(texture.repeat,{
							// 	x:.72
							// });
							$this.staticResource.solarPanel=texture;
							$this.panelOption.public.panelFace=new THREE.MeshBasicMaterial({
								map:$this.staticResource.solarPanel,
								transparent:true,
								// precision:"highp"
								// overdraw:.5,
								// color:stage.color.main
							});
							if(loadedFn) loadedFn();
						});
						break;
				}
			}
			// $.each(this.staticResource,function(key){
			// 	if(!this){
			// 	}
			// });
			return out;
		},
		newPanel:function(list){
			this.resize();
			this.loadResource("solarPanel",()=>{
				// if(designTest(list)){
				// }else alert("组件布局的数据中有重合的坐标");
				if(list){
					let $this=this;
					if(this.notLost(list)==true){//已有组件
						this.drawTypeBLine();
						this.start("reDesign");
					}
					else{//第一次执行or重新创建
						this.clear();
						this.panelInfoCtrl();
						// if(!eTower){
						// 	loader.load(this.panelOption.baseSrc+'eTower.svg',function(texture){
						// 		$.extend(texture.repeat,{
						// 			y:1
						// 		});
						// 		// var $eTower=$(
						// 		// 	'<div>'+
						// 		// 		'<svg class="fillSub dpB mc" style="width:'+this.panelOption.width+'px;height:'+this.panelOption.height+'px">'+
						// 		// 			'<use xlink:href="#ico-eTower"></use>'+
						// 		// 		'</svg>'+
						// 		// 	'</div>'
						// 		// );
						// 		// var eTower=new THREE.CSS2DObject($eTower[0]);
						// 		eTower=new THREE.Mesh(
						// 			new THREE.PlaneBufferGeometry(this.panelOption.width,this.panelOption.height,1),
						// 			new THREE.MeshBasicMaterial({
						// 				map:texture,
						// 				transparent:true,
						// 				// precision:"highp"
						// 				// overdraw:.5,
						// 				color:"#999"
						// 			})
						// 		);
						// 		this.root.add(eTower);
						// 		++this.panelOption.loaded;
						// 	});
						// }
						this.panelOption.maxX=this.panelOption.maxY=0;
						var color=new THREE.Color(stage.color.solarComp);
						// if(this.mode=="view") color=color.setHSL(color.getHSL().h,color.getHSL().s,.6).getStyle();//L:.7-.1
						$(list).each(function(index){
							let x,y;
							x=this[$this.panelOption.keyPos[$this.displayType][0]];
							y=this[$this.panelOption.keyPos[$this.displayType][1]];
							// switch($this.displayType){
							// 	case "a":
							// 		x=this[$this.panelOption.keyPos[$this.displayType][0]];
							// 		y=this[$this.panelOption.keyPos[$this.displayType][1]];
							// 		break;
							// 	case "b":
							// 		x=this[$this.panelOption.keyPos[$this.displayType][1]];
							// 		y=this[$this.panelOption.keyPos[$this.displayType][0]];
							// 		break;
							// }
							if($.isNumeric(x)&&$.isNumeric(y)){
								// var $dom=$(
								// 	'<button class="solarPanel cWhite boxR-light dpB vaM_E" index="'+index+'" id="'+this.id+'" style="width:'+this.panelOption.width+'px;height:'+this.panelOption.height+'px;background-color:'+color+';font-size:'+this.panelOption.fontSize[0]+'px;">'+
								// 		// randomData({max:99999})/100+
								// 	'</button>'
								// );
								// var panel=new THREE.CSS2DObject($dom[0]);
								// var panel=new THREE.Group();
								// panel.receiveShadow=true;
								var panel=new THREE.Mesh(
									$this.panelOption.public.panelGeometry,
									new THREE.MeshBasicMaterial({
										// map:$this.panelOption.texture,
										transparent:true,
										// precision:"highp"
										// overdraw:.5,
										color:color
									})
								);
								panel.xName=x;
								panel.yName=y;
								$.extend(panel,{customData:this});
								panel.name=this.id;
								panel.sn=this.sn||"--";
								// panel.add(panelColor);
								var panelFace=new THREE.Mesh(
									$this.panelOption.public.panelGeometry,
									$this.panelOption.public.panelFace
									// new THREE.MeshBasicMaterial({
									// 	map:$this.staticResource.solarPanel,
									// 	transparent:true,
									// 	// precision:"highp"
									// 	// overdraw:.5,
									// 	// color:stage.color.main
									// })
								);
								panel.add(panelFace);
								var panelText=new THREE.Mesh(
									$this.panelOption.public.panelGeometry,
									// new THREE.TextGeometry( "Hello, World!",{
									// 	size:20, height:1, curveSegments:3,
									// 	font: "monaco", weight: "bold",style: "normal",
									// 	bevelThickness: 1, bevelSize: 2, bevelEnabled: true,
									// 	material: 0, extrudeMaterial: 1
									// }),
									new THREE.MeshBasicMaterial({
										// map:$this.newTextTexture("999.09"),
										transparent:true,
										// precision:"highp"
										// overdraw:.5,
										// color:stage.color.main
									})
								);
								panelText.name="text";
								panel.add(panelText);
								if(x>$this.panelOption.maxX) $this.panelOption.maxX=x;//记录最大x个数
								if(y>$this.panelOption.maxY) $this.panelOption.maxY=y;//记录最大y个数
								// switch($this.displayType){
								// 	case "a":
								// 		break;
								// 	case "b":
								// 		if(x>$this.panelOption.maxY) $this.panelOption.maxY=x;//记录最大y个数
								// 		if(y>$this.panelOption.maxX) $this.panelOption.maxX=y;//记录最大x个数
								// 		// panel.position.set((y-1)*($this.panelOption.width+$this.panelOption.space),(x-1)*($this.panelOption.height+$this.panelOption.space),0);
								// 		break;
								// }
								panel.position.set((x-1)*($this.panelOption.width+$this.panelOption.space),(y-1)*($this.panelOption.height+$this.panelOption.space),0);
								// panel.rotation.set(-randomData({max:90})/10,0,0);
								// TweenMax.set($dom,{z:0,scaleX:1,scaleY:1});
								$this.root.add(panel);
								$this.displayList.push(panel);//纯列表
								$this.interactionList.push(panel);//可交互列表
								$this.panelObjList[String(this.id)]=panel;//索引列表
							}
						});
						if(this.mode=="view"){
							if(this.lastDataOption){//有渲染数据
								this.panelDataRender(this.lastDataOption.data,this.lastDataOption.unit,this.lastDataOption.keyId,this.lastDataOption.keyVal);
							}
							else{
								this.panelDataRender();
							}
						}
						else if(this.mode=="edit"){//编辑模式为了渲染坐标
							this.initCoverSence();
							this.panelDataRender();
						}
						this.drawTypeBLine();
						this.start();
					}//判断是否已有组件end
				}
			});
		},
		initCoverSence(){
//			let maxX = this.panelOption.maxX;
//			let maxY = this.panelOption.maxY;
			let maxX = 2000;
			let maxY = 2000;
			var color=new THREE.Color(stage.color.solarComp);
			let panelW = (maxX) * (this.panelOption.width+this.panelOption.space);
			let panelH = (maxY) * (this.panelOption.height+this.panelOption.space);
			let panelPW = (maxX-1) * (this.panelOption.width+this.panelOption.space);
			let panelPH = (maxY-1) * (this.panelOption.height+this.panelOption.space);
			var panel=new THREE.Mesh(
				new THREE.PlaneGeometry(panelW,panelH,1),
				new THREE.MeshBasicMaterial({
					// map:$this.panelOption.texture,
					transparent:true,
				})
			);
			panel.name='backgroundPanel';
			
			panel.position.set(panelPW*0.5,panelPH*0.5,-0.1);
			this.root.add(panel);
			this.interactionList.push(panel);
		},
		drawTypeBLine:function(){//绘制电气布局连线
			if(this.displayType=="b"){
				this.clearTypeBLine();
				let bList=[];
				$.each(this.displayList,(index,panel)=>{//统计并计算
					let x=panel.customData[this.panelOption.keyPos.b[0]];
					let y=panel.customData[this.panelOption.keyPos.b[1]];
					if(bList[y]){
						if(x<bList[y][0]) bList[y][0]=x;//更新最小值
						else if(x>bList[y][1]) bList[y][1]=x;//更新最大值
					}
					else{
						bList[y]=[x,x];
					}
				});
				$.each(bList,(index,val)=>{//创建连接并动画
					if(val){
						let w=(val[1]-val[0])*(this.panelOption.width+this.panelOption.space);
						let line=new THREE.Mesh(
							new THREE.PlaneGeometry(w,stage.space*.2,1),
							new THREE.MeshBasicMaterial({
								// map:$this.panelOption.texture,
								color:stage.color.neutral,
								opacity:.4,
								transparent:true,
							})
						);
						line.name="typeBLine";
						this.root.add(line);
						line.position.set((val[0]-1)*(this.panelOption.width+this.panelOption.space),(index-1)*(this.panelOption.height+this.panelOption.space),-0.1);
						line.scale.x=0;
						TweenMax.to(line.position,this.baseAniSec,{x:(val[0]-1)*(this.panelOption.width+this.panelOption.space)+w/2,ease:Cubic.easeInOut,delay:this.baseAniSec*.8});
						TweenMax.to(line.scale,this.baseAniSec,{x:1,ease:Cubic.easeInOut,delay:this.baseAniSec*.8,onUpdate:this.render});
						this.typeBLineList.push(line);
					}
				});
			}
		},
		clearTypeBLine:function(){//清除连接线
			$.each(this.typeBLineList,(index,line)=>{
				TweenMax.to(line.material,this.baseAniSec/2,{opacity:0,ease:Cubic.easeInOut,onUpdate:this.render,onComplete:()=>{
					line.geometry.dispose();
					line.material.dispose();
					this.root.remove(line);
				}});
			});
			this.typeBLineList=[];
		},
		build:function($target,option){//构建场景
			if($target) this.$root=$target;
			$.extend(this.panelOption,option);

			// this.cameraSys.look.x=this.panelOption.width*this.data.length;
			var rootSize=[this.$root.width(),this.$root.height()];
			if(!this.camera) this.camera=new THREE.PerspectiveCamera(100,rootSize[0]/rootSize[1],1,this.cameraSys.max.z);//视野角,纵横比,相机离视体积最近的距离,相机离视体积最远的距离
			// var contentArea=new Array(
			// 	(this.panelOption.width+this.panelOption.space)*(this.panelOption.maxX),
			// 	(this.panelOption.height+this.panelOption.space)*(this.panelOption.maxY+1)
			// );
			// if(!this.camera) camera=new THREE.OrthographicCamera(-contentArea[0]*.2,contentArea[0]*1.2,contentArea[1]*1.2,-contentArea[1]*.2,1,this.cameraSys.max.z);
			// this.camera.up.x = 0;//设置相机的上为「x」轴方向
			// this.camera.up.y = 1;//设置相机的上为「y」轴方向
			// this.camera.up.z = 0;//设置相机的上为「z」轴方向
			// this.camera.lookAt(cameraSys.look);//设置视野的中心坐标

			this.renderWebGL.setSize(rootSize[0],rootSize[1]);
			this.renderCSS2D.setSize(rootSize[0],rootSize[1]);
			if(this.$root.find(".renderCSS2D").length==0){
				// $(this.renderCSS2D.domElement).css({
				// 	// "pointer-events":"none",
				// 	position:"absolute",
				// 	top:0,
				// 	left:0
				// });
				$(this.renderCSS2D.domElement).addClass("renderCSS2D");
				this.$root.prepend(this.renderCSS2D.domElement);
			}
			if(this.$root.find(".renderWebGL").length==0){
				$(this.renderWebGL.domElement).css("display","none");
				$(this.renderWebGL.domElement).addClass("renderWebGL");
				this.$root.prepend(this.renderWebGL.domElement);
			}

			if(!this.panelInfo&&this.panelOption.selector.panelInfo){
				this.panelOption.infoWidth=$(this.$el).find(this.panelOption.selector.panelInfo).width();
				this.panelInfo=new THREE.CSS2DObject($(this.$el).find(this.panelOption.selector.panelInfo)[0]);
				// this.root.add(this.panelInfo);
				// $(this.panelOption.panelInfo).css("opacity",0);
				this.setPanelInfoSize();
			}
			if(!this.panelTip&&this.panelOption.selector.panelTip){//新建组件提示框
				this.panelTip=new THREE.CSS2DObject($(this.$el).find(this.panelOption.selector.panelTip)[0]);
				// panelTip.position.z=50;
				// this.root.add(this.panelTip);
				// $(this.panelOption.panelTip).css("opacity",0);
			}
			this.render();
				// TweenMax.to(this,3,{onUpdate:this.render});
				// this.render();
				// controls = new THREE.TrackballControls( this.camera );
			 //    //旋转速度
			 //    controls.rotateSpeed = 1.0;
			 //    //变焦速度
			 //    controls.zoomSpeed = 1.2;
			 //    //平移速度
			 //    controls.panSpeed = 0.8;
			 //    //是否不变焦
			 //    controls.noZoom = false;
			 //    //是否不平移
			 //    controls.noPan = true;
			 //    //可能是惯性 true没有惯性
			 //    controls.staticMoving = false;
			 //    //动态阻尼系数 就是灵敏度
			 //    controls.dynamicDampingFactor = 0.3;
			this.$root.off("mousedown");
			this.$root.on("mousedown",e=>{
				this.mouse.x = ( e.offsetX/this.$root.width()) * 2 - 1;
				this.mouse.y = - ( e.offsetY/this.$root.height()) * 2 + 1;
				var vector = new THREE.Vector3( this.mouse.x, this.mouse.y, 0.5 ).unproject( this.camera );
				var raycaster = new THREE.Raycaster( this.camera.position, vector.sub( this.camera.position ).normalize() );
				raycaster.setFromCamera( this.mouse, this.camera );
				var targets = raycaster.intersectObjects(this.interactionList);
				
				if(targets.length>1){//点击的为板子，
					let component={};
					targets.map(item=>{
						if(item.object.name != 'backgroundPanel') component = {id:item.object.name,sn:item.object.sn}
					})
					this.$emit('ComponentSelect',{e,component,fromPanel:true})
				} else if(this.lock==false){
					this.click=true;
					// this.$root.css("cursor","move");
					this.downPoint=[e.clientX,e.clientY];
					this.cameraSys.loc.x=this.camera.position.x;
					this.cameraSys.loc.y=this.camera.position.y;
					$(document).on("mousemove",this.panelDrag);
					$(window).on("mouseup",this.panelDragEnd);
					this.$root.on("mouseleave",this.panelDragEnd);
					// $(window).on("mouseleave",this.panelDragEnd);
				}
				var clear= "getSelection" in window ? function(){
					window.getSelection().removeAllRanges();
				} : function(){
					document.selection.empty();
				};
				clear();
				// return false;
			});
			if(this.panelInfo){
				$(this.$el).find(this.panelOption.selector.panelInfo).off("mousedown");
				$(this.$el).find(this.panelOption.selector.panelInfo).on("mousedown",e=>{
					this.click=false;
					setTimeout(this.panelDragEnd,0);
					e.stopPropagation();
				});
			}
			this.$root.off("mousemove");
			this.$root.on("mousemove",e=>{//鼠标移动检测
				if($(e.target).is("[class*='render']")&&this.click==true&&this.lock==false){//.hasClass("renderCSS2D")
					this.mouse.x = ( e.offsetX/this.$root.width())*2 - 1;
					this.mouse.y = - ( e.offsetY/this.$root.height())*2 + 1;
					var vector = new THREE.Vector3( this.mouse.x, this.mouse.y, 0.5 ).unproject( this.camera );
					var raycaster = new THREE.Raycaster( this.camera.position, vector.sub( this.camera.position ).normalize() );
					raycaster.setFromCamera( this.mouse, this.camera );
					var targets = raycaster.intersectObjects(this.interactionList);
					if(this.mode=="edit"){//编辑模式
						if(targets.length>1){
							// if(!this.panelOption.hover||this.panelOption.hover.name!=targets[0].object.name){
							// 	this.panelOption.hover=targets[0].object;
							// }
							this.panelTipCtrl(targets[0].object);
						}
						else this.panelTipCtrl();
					}else{
						if(targets.length){
							// if(!this.panelOption.hover||this.panelOption.hover.name!=targets[0].object.name){
							// 	this.panelOption.hover=targets[0].object;
							// }
							if(this.$root.hasClass("curM")){
								this.$root.removeClass("curM").addClass("curP");
							}
							this.panelTipCtrl(targets[0].object);
						}
						else if(this.$root.hasClass("curP")){
							this.$root.removeClass("curP").addClass("curM");
							this.panelTipCtrl();//targets.length?targets[0].object:
						}
					}
				}
			});
			this.$root.off("mouseleave");
			this.$root.on("mouseleave",e=>{//移出的时候隐藏tip
				this.panelTipCtrl();
			});
			this.$root.off("mouseup");
			this.$root.on("mouseup",e=>{
//				console.log(this.curComponent);
//				console.log(this.panelObjList)
				this.mouse.x = ( e.offsetX/this.$root.width()) * 2 - 1;
				this.mouse.y = - ( e.offsetY/this.$root.height()) * 2 + 1;
				var vector = new THREE.Vector3( this.mouse.x, this.mouse.y, 0.5 ).unproject( this.camera );
				var raycaster = new THREE.Raycaster( this.camera.position, vector.sub( this.camera.position ).normalize() );
				raycaster.setFromCamera( this.mouse, this.camera );
				var targets = raycaster.intersectObjects(this.interactionList);
				
				let xn=0,yn=0;
				if(targets.length >= 1) {//有target 才能获取位置
					let x = targets[0].point.x;
					let y = targets[0].point.y;
					let pw = this.panelOption.width+this.panelOption.space
					let ph = this.panelOption.height+this.panelOption.space
					
					xn = Math.ceil((x+(pw*0.5))/pw);
					yn = Math.ceil((y+(ph*0.5))/ph);
					
				}
				else if(this.displayList.length==0&&this.displayType=="b"){//电气布局中，新拖入的始终为1
					xn=1;
					yn=1;
				}
				if(xn>0&&yn>0){
					let positionAble = true;//当前位置是否可用（点击位置上是否已经被占用）
					
					if(this.curComponent && this.curComponent.id) { //当前是拖动的状态
						let panelObj = this.panelObjList[this.curComponent.id];
						
						// console.log(xn, yn,this.curComponent.sn)
						if(this.panelObjList) for(let k in this.panelObjList){
							// if(this.panelObjList[k].xName == xn && this.panelObjList[k].yName == yn) positionAble = false;
							// console.log(this.panelObjList[k].customData[this.panelOption.keyPos[this.displayType][0]],this.panelObjList[k].customData[this.panelOption.keyPos[this.displayType][1]])
							if(this.panelObjList[k].customData[this.panelOption.keyPos[this.displayType][0]] == xn && this.panelObjList[k].customData[this.panelOption.keyPos[this.displayType][1]] == yn){//坐标判断
								positionAble = false;
							}
						}
//						console.log(panelObj)
						if(positionAble){
							// if(this.displayType=="b"){//电气模式点击落点修正
							// 	let maxX=1,maxY=1;
							// 	$.each(this.displayList,(index,val)=>{
							// 		if(val.customData[this.panelOption.keyPos.b[1]]==yn){//组串修正，同一x轴
							// 			if(val.name!=this.curComponent.id&&val.customData[this.panelOption.keyPos.b[0]]>=maxX){//找出最大x
							// 				maxX=val.customData[this.panelOption.keyPos.b[0]]+1;
							// 				maxY=yn;
							// 			}
							// 		}
							// 		else{
							// 			// if(val.customData[this.panelOption.keyPos.b[0]]!=xn){//并联行修正，同一y轴
							// 				if(val.name!=this.curComponent.id&&val.customData[this.panelOption.keyPos.b[1]]>=maxY){//找出最大y
							// 					maxX=1;
							// 					maxY=val.customData[this.panelOption.keyPos.b[1]]+1;
							// 				}
							// 			// }
							// 		}
							// 	});
							// 	xn=maxX;
							// 	yn=maxY;
							// }
							this.$emit('DragSuccess',{
								component:this.curComponent,
								xn,yn
							});
							this.updatePanelPosition(panelObj,xn,yn,this.curComponent.id);
						}
					}
				}
			});
			this.$root.off("click");
			this.$root.on("click",e=>{//点击选中组件查看详情
				this.mouse.x = ( e.offsetX/this.$root.width()) * 2 - 1;
				this.mouse.y = - ( e.offsetY/this.$root.height()) * 2 + 1;
				var vector = new THREE.Vector3( this.mouse.x, this.mouse.y, 0.5 ).unproject( this.camera );
				var raycaster = new THREE.Raycaster( this.camera.position, vector.sub( this.camera.position ).normalize() );
				raycaster.setFromCamera( this.mouse, this.camera );
				var targets = raycaster.intersectObjects(this.interactionList);
				if(this.click&&this.lock==false&&this.mode=="view"){
					this.click=false;
					// trace(targets[0],true);
					// var name="";
					this.panelInfoCtrl(targets.length?targets[0].object:null);
				}
				else if(this.click&&this.lock==false&&this.mode=="edit"){
					this.panelOption.active=targets.length>1?targets[0].object:null;
				}
			});
		},
		positionFix:function(){
			if(this.displayType=="b"){//电气阵列检测修正
				let posArray=new Array(this.panelOption.maxY);
				$.each(this.displayList,(index,panel)=>{//以行统计
					let y=panel.customData[this.panelOption.keyPos[this.displayType][1]];
					if(!posArray[y-1]) posArray[y-1]=[];
					posArray[y-1].push(panel);
				});
				//空行修正
				let i=0;
				// let posArrayByX=[];//x纬度的列表
				while(i<posArray.length){
					if(!posArray[i]){
						posArray.splice(i,1);
					}
					else{
						// posArrayByX[i]=[];
						posArray[i].sort((a,b)=>{
							return a.customData[this.panelOption.keyPos[this.displayType][0]]-b.customData[this.panelOption.keyPos[this.displayType][0]];
						});
						$.each(posArray[i],(index,panel)=>{
							panel.yName=i+1;
							panel.customData[this.panelOption.keyPos[this.displayType][1]]=i+1;//批量更新行坐标
							panel.xName=index+1;
							panel.customData[this.panelOption.keyPos[this.displayType][0]]=index+1;//批量更新x坐标
						});
						++i;
					}
				}
				//空格修正
				$.each(this.displayList,(index,panel)=>{
					TweenMax.to(panel.position,.5,{x:(panel.customData[this.panelOption.keyPos[this.displayType][0]]-1)*(this.panelOption.width+this.panelOption.space),y:(panel.customData[this.panelOption.keyPos[this.displayType][1]]-1)*(this.panelOption.height+this.panelOption.space),ease:Cubic.easeOut,onUpdate:this.render});
				});
			}
			this.panelDataRender();
			this.drawTypeBLine();
			this.emitUpdate();
		},
		updatePanelPosition(panelObj,xn,yn,id){//更新panel位置
			if(!panelObj){
				// console.log('isNew',this.curComponent)
				var panel=new THREE.Mesh(
					new THREE.PlaneGeometry(this.panelOption.width,this.panelOption.height,1),
					new THREE.MeshBasicMaterial({
						// map:this.panelOption.texture,
						transparent:true,
						// precision:"highp"
						// overdraw:.5,
//						color:new THREE.Color(stage.color.solarComp)
					})
				);
				panel.sn=this.curComponent.sn||"--";
				panel.name=id;
				// panel.add(panelColor);
				var panelFace=new THREE.Mesh(
					this.panelOption.public.panelGeometry,
					this.panelOption.public.panelFace
				);
				panel.add(panelFace);
				var panelText=new THREE.Mesh(
					this.panelOption.public.panelGeometry,
					new THREE.MeshBasicMaterial({
						transparent:true,
					})
				);
				panelText.name="text";
				panel.add(panelText);
				panel.position.set((xn-1)*(this.panelOption.width+this.panelOption.space),(yn-1)*(this.panelOption.height+this.panelOption.space),0);
				this.root.add(panel);
				this.displayList.push(panel);
				this.interactionList.push(panel);
				this.panelObjList[String(id)]=panel;
			}
			else{
				// console.log('isUpdate')
				TweenMax.to(panelObj.position,.5,{x:(xn-1)*(this.panelOption.width+this.panelOption.space),y:(yn-1)*(this.panelOption.height+this.panelOption.space),ease:Cubic.easeOut,onUpdate:this.render});
//				this.render();
			}
			panelObj=this.panelObjList[String(id)];
			panelObj.xName=xn;
			panelObj.yName=yn;
			this.curComponent[this.panelOption.keyPos[this.displayType][0]]=xn;
			this.curComponent[this.panelOption.keyPos[this.displayType][1]]=yn;
			panelObj.customData=this.curComponent;
			// panelObj.customData[this.panelOption.keyPos[this.displayType][0]]=xn;
			// panelObj.customData[this.panelOption.keyPos[this.displayType][1]]=yn;
			
			this.updateMaxPosition();
			this.positionFix();//检测修正排布
		},
		updateMaxPosition(){//更新阵列最大数据
			this.panelOption.maxX=this.panelOption.maxY=0;
			$.each(this.displayList,(index,panel)=>{
				let x=panel.customData[this.panelOption.keyPos[this.displayType][0]];
				let y=panel.customData[this.panelOption.keyPos[this.displayType][1]];
				if(x>this.panelOption.maxX) this.panelOption.maxX=x;//记录最大x个数
				if(y>this.panelOption.maxY) this.panelOption.maxY=y;//记录最大y个数
			});
		},
		clear:function(target){//清除画布内容
			let $this=this;
			function destroy(t,clearPosData){
				t.geometry.dispose();
				t.material.dispose();
				$this.root.remove($this.root.getObjectByName(t.name));
				delete $this.panelObjList[t.name];
				$this.displayList.splice(lib.objTool($this.displayList,"findByKey",["name",t.name])[0],1);
				$this.interactionList.splice(lib.objTool($this.interactionList,"findByKey",["name",t.name])[0],1);

				if($this.mode=="edit"&&clearPosData){
					let thisData=$this.data[lib.objTool($this.data,"findByKey",["id",t.name])[0]];//找出并更改原始列表数据
					if(thisData){//有效组件数据才清空数据
						thisData[$this.panelOption.keyPos[$this.displayType][0]]=null;
						thisData[$this.panelOption.keyPos[$this.displayType][1]]=null;
					}
				}
				t=null;
			}
			if(target){
				destroy(target,true);
				this.positionFix();
			}
			else{
				$.each([...this.root.children],(index,panel)=>{//清空
					destroy(panel);
				});
				this.displayList=[];
				this.typeBLineList=[];
				this.interactionList=[];
				this.panelOption.valTexture={};
				this.root.dispose();
			}
			this.$nextTick(()=>{
				this.render();
			});
		},
		zoomIn:function(){//镜头控制
			this.lock=true;
			TweenMax.to(this.camera.position,.5,{
				z:(this.camera.position.z-this.camera.position.z/3>=this.cameraSys.min.z)? this.camera.position.z-this.camera.position.z/3:this.cameraSys.min.z,
				ease:Expo.easeOut,
				onUpdate:()=>{this.setPanelInfoSize();this.render();},
				onComplete:()=>{
					this.lock=false;
					this.zoomEndFun();
				}
			});
		},
		zoomOut:function(){//镜头控制
			this.lock=true;
			TweenMax.to(this.camera.position,.5,{
				z:(this.camera.position.z+this.camera.position.z/3<=this.cameraSys.max.z)? this.camera.position.z+this.camera.position.z/3:this.cameraSys.max.z,
				ease:Expo.easeOut,
				onUpdate:()=>{this.setPanelInfoSize();this.render();},
				onComplete:()=>{
					this.lock=false;
					this.zoomEndFun();
				}
			});
    },
    zoomEndFun:function(){
      if(this.mode=="view"){
        return
      }
      let change = false
      let z =this.camera.position.z
          let zn = z - this.newZ
          let offestH = Math.tan(50 * Math.PI / 180)*z
           var  asp = this.$root.width()/this.$root.height()
          let offestW = offestH*asp
          var np = {x:this.newX,y:this.newY}
          this.newY = Math.tan(50 * Math.PI / 180)*zn + this.newY
          this.newX = this.newY*asp
          if(this.camera.position.x<this.newX&&this.mode!=="view"){
             np.x = this.newX
             change = true
          }
          if(this.camera.position.y<this.newY&&this.mode!=="view"){
            np.y = this.newY
            change = true
          }
          this.newZ = z

          if(change){
              TweenMax.to(this.camera.position,1,{
                x:np.x,
                y:np.y,
                ease:Cubic.easeInOut,
                onUpdate:()=>{this.setPanelInfoSize();this.render();}
              });
          }
       
    },
		resetView:function(){//镜头控制
			this.lock=true;
			TweenMax.to(this.camera.position,1,{
				x:this.cameraSys.def().x,y:this.cameraSys.def().y,z:this.cameraSys.def().z,
				ease:Cubic.easeInOut,
				onUpdate:()=>{this.setPanelInfoSize();this.render();},
				onComplete:()=>{
					this.lock=false;
				}
			});
		},
		panelReview:function(){//镜头控制
			TweenMax.to(this.camera.position,1,{x:(this.panelOption.width+this.panelOption.space)*this.panelOption.maxX*.5,y:(this.panelOption.height+this.panelOption.space)*(this.panelOption.maxY-1.5),z:this.cameraSys.min.z*5,ease:Cubic.easeInOut,
				onUpdate:this.render,
				// onComplete:()=>{this.lock=false;}
			});
    },
    aniToZero(z){      
      var witchMax = ''  
      var z
      var newX, newY
      var  asp = this.$root.width()/this.$root.height();
		let maxX=this.panelOption.maxX,maxY=this.panelOption.maxY;
		switch(this.mode){//处理最小画面的基础数据
			case "view":
				if(maxX<2) maxX=2;
				if(maxY<2) maxY=2;
				break;
			case "edit":
				if(maxX<6) maxX=6;
				if(maxY<6) maxY=6;
				break;
		}
      let	x=this.panelOption.width+(this.panelOption.width+this.panelOption.space)*maxX*.5 - (this.panelOption.width/2) 
			let	y=this.panelOption.width+(this.panelOption.height+this.panelOption.space)*maxY/2 - (this.panelOption.height/2)
      var mw =this.panelOption.width+ (this.panelOption.width+this.panelOption.space)*maxX;
      var mh =this.panelOption.width+ (this.panelOption.height+this.panelOption.space)*maxY;
      var mx = mw>mh?mw:mh
      // 获取视角x的高/2
    newX = x
    newY = y
      // 高度 》 宽度
        if (mh>=mw) {
          z = (1/Math.tan(50* Math.PI / 180))*(mx/2)
          newX = offestW
          witchMax = 'height'
        }else { // 高度 《 宽度
          z = (mx/2)/(Math.tan(50 * Math.PI / 180)*asp)
          newY = offestH
          witchMax = 'width'
        }
          let offestH = Math.tan(50 * Math.PI / 180)*z
      let offestW = offestH*asp
      //贴边算法offestW - this.panelOption.width/2
   if (mh>=mw) {
          newX = offestW - (this.panelOption.width/2)
         
        }else { // 高度 《 宽度
      
          newY = offestH - (this.panelOption.height/2)
         
        }
      switch (witchMax) {
          case 'height':
            if (offestW < x) {
              // z = (1/Math.tan(50*asp* Math.PI / 180))*(mx/2)
              // x = x +(offestW - x)
               z =x/(Math.tan(50 * Math.PI / 180)*asp)
               offestH = Math.tan(50 * Math.PI / 180)*z
               offestW = offestH*asp
               newY = offestH - (this.panelOption.height/2)
            }
            break
          case 'width':
            if (offestH < y) {
              z = ((1/Math.tan(50* Math.PI / 180))*y)
              offestH = Math.tan(50 * Math.PI / 180)*z
              offestW = offestH*asp
              newX = offestW - (this.panelOption.width/2)
            }
        }
        this.newX = newX = newX - (this.panelOption.width/2) - (this.panelOption.width/2)
        this.newY = newY = newY - (this.panelOption.width/2)- (this.panelOption.width/2)
      return {x: newX,y: newY,z:z}
    },
		resize:function(){
			lib.fillHeight();
			if(this.camera&&this.renderWebGL){
				// this.camera.fov=(this.$root.height()/this.panelOption.minHeight)*40<=160? (this.$root.height()/this.panelOption.minHeight)*40:160;
				this.camera.aspect=this.$root.width()/this.$root.height();
				this.camera.updateProjectionMatrix();

				this.renderWebGL.setSize(this.$root.width(),this.$root.height());
			}
			if(this.renderCSS2D) this.renderCSS2D.setSize(this.$root.width(),this.$root.height());
			this.zoomEndFun();
			this.render();
			// var array=[this.$root.width(),0];
			// TweenMax.to(array,1,{endArray:[targetWidth,0],ease:Cubic.easeInOut,onUpdate:function(){trace(array)
			// }});
		},
		cancelPreview(){
			this.$emit('CancelPreview')
		},
		comDetail(option){
			this.$dynamic($(this.$el)[0],ViewDetail,
				{type:1,bg:true},
				{},{}
			).then(({instance, childInstance}) => {
					childInstance.show(option,instance);
				}
			);
		},
		onDelete:function(e){
			if(["Delete","Backspace"].indexOf(e.key)>=0&&this.panelOption.active){
				this.clear(this.panelOption.active);
				this.panelOption.active=null;
				this.drawTypeBLine();
			}
		}
	},
	computed:{
	},
	created(){
		this.load();

		this.panelOption.space=this.panelOption.height*.2;

		this.cameraSys={
			"loc":{x:0,y:0,z:0},
			"look":{x:0,y:0,z:0},
      "def":()=>{//默认位置
        // this.$root.width(),this.$root.height()
		let maxX=this.panelOption.maxX,maxY=this.panelOption.maxY;
        var x,y,z;
        var mw = (this.panelOption.width+this.panelOption.space)*maxX - this.panelOption.space
        var mh = (this.panelOption.height+this.panelOption.space)*maxY - this.panelOption.space
        var mx = mw>mh?mw:mh
        var witchMax = ''
				x=(this.panelOption.width+this.panelOption.space)*maxX*.5-(this.panelOption.width+this.panelOption.space)/2;
        y=(this.panelOption.height+this.panelOption.space)*maxY/2 - (this.panelOption.height/2);
        var trueH = (this.panelOption.height+this.panelOption.space)*maxY/2 - (this.panelOption.space/2);
        var trueW = (this.panelOption.width+this.panelOption.space)*maxX*.5-(this.panelOption.space/2);
        // z=this.cameraSys.min.z*1.5;
        var  asp = this.$root.width()/this.$root.height()
        //计算度数

        // 高度 》 宽度
        if (mh>=mw) {
          z = ((1/Math.tan(50* Math.PI / 180))*y + this.panelOption.space)/.8
          // x = (z*Math.tan(50 * Math.PI / 180)*asp)
          witchMax = 'height'
        }else { // 高度 《 宽度
          z =x/(Math.tan(50 * Math.PI / 180)*asp)/.8
          // y = z*Math.tan(50 * Math.PI / 180)
          witchMax = 'width'
        }
        // 获取视角x的高/2
        let offestH = Math.tan(50 * Math.PI / 180)*(z)
        let offestW = offestH*asp
        switch (witchMax) {
          case 'height':
            if (offestW < trueW) {
             z =(x)/(Math.tan(50 * Math.PI / 180)*asp)/.8
            //  y = z*Math.tan(50 * Math.PI / 180)
            }
            break
          case 'width':
            if (offestH < trueH) {
             z = ((1/Math.tan(50* Math.PI / 180))*y + this.panelOption.space)/.8
              // x = (z*Math.tan(50 * Math.PI / 180)*asp)
            }
        }
        if (this.mode === 'edit'){
          let ax = this.aniToZero((z/.8),witchMax)
          x = ax.x
          y = ax.y
          z = ax.z
        }
        this.newZ= z
         // this.cameraSys.max.z = z*2   
         if(z<this.cameraSys.min.z){
           this.newZ=100
           z=100
         }
				return {x:x,y:y,z:z};
			},
			"min":{x:0,y:0,z:100},
			"max":{x:0,y:0,z:8000}
		};
	},
	mounted(){
		// $.getScript("/static/js/three.min.js",function(){
		// 	trace("sdasdasd")
		// });
		lib.fillHeight();
		if(window.THREE){
			this.threeReady("0");
		}
		else{
			$.get(stage.loc.baseRouter+"static/js/three.min.js",()=>{
				this.threeReady("0");
			});
		}
		if(window.THREE&&THREE.CSS2DRenderer){
			this.threeReady("1");
		}
		else{
			$.get(stage.loc.baseRouter+"static/js/CSS2DRenderer.js",data=>{//由于异步，会导致报错，但不影响
				this.threeReady("1",data);
			});
		}
		if(window.TweenMax){
			this.threeReady("2");
		}
		else{
			$.get(stage.loc.baseRouter+"static/js/TweenMax.min.js",()=>{
				this.threeReady("2");
			});
		}

		if(this.mode=="edit") $(window).on("keyup",this.onDelete);
	},
	destroyed(){
		$(window).off("resize",this.resize);
		$(window).off("keyup",this.onDelete);
		this.clear();
		this.renderWebGL.dispose();
		// this.renderCSS2D.dispose();
		this.data=null;
	}
}
</script>
<style lang="scss" scoped>
.goToEdit{width:100%;margin:{top:-3em;};position:absolute;top:50%;left:0;z-index:1;}
.classGroup{display:block;text-align:center;font-size:0;
	>*{float:unset;font-size:1rem;}
}
.noData{position:absolute;top:0;left:0;}
</style>


// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/layout/PanelDisplay.vue